import { FieldProps, getIn } from 'formik';
import { CvvInput } from '@shared/inputs/CvvInput';
import { CreditCardTypeEnum } from '@modules/ContactManager/components/Tabs/components/Deals/components/DownPaymentModal/types';
import { AMERICAN_EXPRESS_CREDIT_CARD_CVV_LENGTH, CVV_LENGTH } from '@shared/constants/constants';

interface IProps extends FieldProps {
  id?: string;
  isAmericaExpressCard?: boolean;
}
export const AmericanExpress = CreditCardTypeEnum.AmericanExpress.replace(' ','');

export const CvvInputField = ({ form, field, ...props }: IProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const maxLength = form.values.creditCardType === AmericanExpress ? AMERICAN_EXPRESS_CREDIT_CARD_CVV_LENGTH : CVV_LENGTH;

  return (
    <CvvInput
      {...field}
      {...props}
      inputProps={{ maxLength }}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
